import {createFileRoute, redirect} from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/_admin/_legacy/customers")({
  beforeLoad: () => {
    throw redirect({to: "/admins/customers", replace: true});
  },
});
